(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-controls.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-controls.js');

'use strict';

const centerSwedenSvg = "\n    <svg viewBox=\"0 0 112 260\" fill=\"currentColor\" aria-hidden=\"true\">\n      <polygon points=\"109.627,57.925 104.224,46.74 105.859,39.394 95.337,12.782 88.204,10.294 79.555,2 75.692,3.421 73.773,14.085\n  61.474,11.431 47.872,32.711 50.099,39.583 43.346,52.711 36.308,57.001 34.53,75.864 28.891,85.698 31.094,96.456 20.739,97.191\n  14.506,109.395 16.426,128.495 14.648,138.661 20.762,145.486 16.592,168.756 8.321,178.827 9.293,184.681 2.373,189.562\n  2.61,200.179 8.866,203.923 8.843,215.795 18.203,236.838 18.345,255.511 21.497,258 33.037,254.872 35.123,245.014 48.654,244.35\n  56.758,218.354 57.114,196.648 72.517,186.6 76.617,174.941 66.545,159.609 61.569,159.348 58.607,144.964 61.593,130.888\n  61.829,125.248 75.811,105.627 87.304,97.001 92.304,86.267 91.593,74.086 96.024,58.636 \" />\n    </svg>\n  ";
const addControlZoomUi = function (map) {
  let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    onCenter = _ref.onCenter;
  const zoomControl = leaflet.control.zoom({
    position: 'bottomleft',
    zoomInText: "\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n      <path d=\"M12.75 11H21V12.5H12.75V21H11.25V12.5H3V11H11.25V3H12.75V11Z\" fill=\"white\"/>\n    </svg>\n  ",
    zoomOutText: "\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\n      <path d=\"M2.75 11H20.75V12.5H2.75V11Z\" fill=\"white\"/>\n    </svg>\n  ",
    zoomInTitle: 'Zooma in',
    zoomOutTitle: 'Zooma ut'
  }).addTo(map);
  if (typeof onCenter === 'function') {
    const container = zoomControl.getContainer();
    const zoomOutButton = container.querySelector('.leaflet-control-zoom-out');
    const centerButton = leaflet.DomUtil.create('a', 'leaflet-control-zoom-center');
    centerButton.href = '#';
    centerButton.title = 'Visa hela Sverige';
    centerButton.setAttribute('role', 'button');
    centerButton.setAttribute('aria-label', 'Visa hela Sverige');
    centerButton.innerHTML = centerSwedenSvg;
    container.insertBefore(centerButton, zoomOutButton);
    leaflet.DomEvent.on(centerButton, 'click', e => {
      leaflet.DomEvent.stop(e);
      onCenter();
    });
  }
};
Object.assign(svs.lyckoplatsen.components.shared_map, {
  addControlZoomUi
});

 })(window);